import { request } from '@/service/http'

export interface ToDoItemFinsh {
  /**
   * 是否要全部设置已完成,默认0,否,1是
   */
  allFinsh?: number
  /**
   * 要设置完成的记录
   */
  idList?: string[] | number[]
  [property: string]: any
}

/**
 *  更新会员资料
 */
export function updateMembershipInformation(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<User.Membercenter.MemberShipInfo>>('/user/membercenter/updateMembershipInformation', data)
  return methodInstance
}

/**
 *  更新新手任务状态(占位,后端接口待接入)
 */
export function setNoviceTaskStatus(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user/membercenter/updateNewUserStatus', data)
  return methodInstance
}

/**
 *  公告列表
 */
export function premessageGetList(data: Search.Common) {
  const methodInstance = request.Post<Service.ResponseResult<User.Premessage.Info>>('/user/premessage/getList', data)
  return methodInstance
}

/**
 *  公告详情
 */
export function getNoticeInfo(params: { id: string }) {
  const methodInstance = request.Get<Service.ResponseResult<any>>('/user/premessage/getNoticeInfo', { params })
  return methodInstance
}

/**
 *  通知详情
 */
export function premessageGetInfo(params: { id: string }) {
  const methodInstance = request.Get<Service.ResponseResult<any>>('/user/premessage/getInfo', { params })
  return methodInstance
}

/**
 *  设置通知已读
 */
export function setReaded(params: { id: number | string }) {
  const methodInstance = request.Get<Service.ResponseResult<any>>('/user/premessage/setReaded', { params })
  return methodInstance
}

/**
 *  查询上一条/下一条消息
 */
export function premessageGetPrevAndNext(params: { id: number | string }) {
  const methodInstance = request.Get<Service.ResponseResult<any>>('/user/premessage/getPrevAndNext', { params })
  return methodInstance
}

/**
 *  设置公告已读
 */
export function setReadedForNotice(params: { id: number | string }) {
  const methodInstance = request.Get<Service.ResponseResult<any>>('/user/premessage/setReadedForNotice', { params })
  return methodInstance
}

/**
 *  设置/取消 待办状态
 */
export function setToDoStatus(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user/premessage/setToDoStatus', data)
  return methodInstance
}

/**
 *  实名认证详情信息
 */
export function getRealNameInfo() {
  const methodInstance = request.Get<Service.ResponseResult<User.Realname.Info>>('/user/realname/getRealNameInfo')
  return methodInstance
}

/**
 *  实名认证详情信息
 */
export function manualVerification(data: User.Realname.Form) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user/realname/manualVerification', data)
  return methodInstance
}

/**
 *  重置实名
 */
export function resetAuth(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user/realname/resetAuth', data)
  return methodInstance
}

/**
 *  待办事项列表查询
 */
export function pretodoitemGetList(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<Search.Common>>('/user/pretodoitem/getList', data)
  return methodInstance
}

/**
 *  添加待办事项
 */
export function pretodoitemAddData(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<User.Pretodoitem.Add>>('/user/pretodoitem/addData', data)
  return methodInstance
}

/**
 *  修改待办事项
 */
export function pretodoitemUpdateDate(data: any) {
  const methodInstance = request.Put<Service.ResponseResult<User.Pretodoitem.Add>>('/user/pretodoitem/updateDate', data)
  return methodInstance
}

/**
 *  删除待办事项
 */
export function pretodoitemDeleteData(idList: number[]) {
  const methodInstance = request.Delete<Service.ResponseResult<any>>(`/user/pretodoitem/deleteData`, { idList })
  return methodInstance
}

/**
 *  完成待办事项
 */
export function pretodoitemSetToDoItemFinsh(data: ToDoItemFinsh) {
  const methodInstance = request.Put<Service.ResponseResult<User.Pretodoitem.Add>>('/user/pretodoitem/setToDoItemFinsh', data)
  return methodInstance
}

/**
 *  查询待办提醒信息
 */
export function pretodoitemGetListGet() {
  const methodInstance = request.Get<Service.ResponseResult<any>>('/user/pretodoitem/getList')
  return methodInstance
}

/**
 *  设置待办提醒信息已读
 */
export function pretodoitemsetReadAlready(id: number) {
  const methodInstance = request.Get<Service.ResponseResult<any>>(`/user/pretodoitem/setReadAlready?id=${id}`)
  return methodInstance
}
